/* Viretta collection.v2-saet / v2-gaver (snippets/v2-col-saet, v2-col-gaver, v2-col-combo):
   area chips (sets), people + price + occasion filters (gifts), »Se alle«, and »Læg alle tre i kurv« (one /cart/add.js call, then
   the theme's cart drawer via cart:refresh + opening it). */
(() => {
  if (window.V2ColSpecial) return; window.V2ColSpecial = true;

  /* Sets: one area at a time, 8 first */
  const initAreas = (root) => {
    const cells = [...root.querySelectorAll('.v2-col__cell')];
    const count = root.querySelector('[data-v2-areacount]');
    const allBtn = root.querySelector('[data-v2-areaall]');
    const apply = (area) => {
      root.querySelectorAll('[data-v2-area]').forEach((b) => { const on = b.dataset.v2Area === area; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', String(on)); });
      let shown = 0;
      cells.forEach((c) => { const hit = !area || c.dataset.area === area; c.hidden = !hit; if (hit) shown++; });
      root.classList.toggle('is-all', !!area);
      if (count) count.textContent = area ? `${shown} Sets` : `${Math.min(8, cells.length)} von ${cells.length} Sets`;
      if (allBtn) allBtn.hidden = !!area || cells.length <= 8;
    };
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-v2-area]'); if (b) { apply(b.dataset.v2Area); return; }
      if (e.target.closest('[data-v2-areaall]')) { root.classList.add('is-all'); if (count) count.textContent = `${cells.length} von ${cells.length} Sets`; allBtn.hidden = true; }
    });
  };

  /* Gifts: who + price band + occasion (occasions map to people) */
  const initGifts = (root) => {
    const cells = [...root.querySelectorAll('.v2-col__cell')];
    const st = { who: '', band: '', occ: null };
    const title = root.querySelector('[data-v2-gtitle]'), cnt = root.querySelector('[data-v2-gcount]');
    const seen = root.querySelector('[data-v2-gseen]'), allBtn = root.querySelector('[data-v2-gall]'), none = root.querySelector('[data-v2-gnone]');
    const names = {}; root.querySelectorAll('.v2-gf__pc').forEach((p) => { names[p.dataset.v2Who] = p.querySelector('b').textContent; });
    const apply = () => {
      const [lo, hi] = st.band ? st.band.split('-').map(Number) : [0, Infinity];
      const occ = st.occ ? st.occ.split(' ') : null;
      let n = 0;
      cells.forEach((c) => {
        const who = c.dataset.who.split(' '), price = Number(c.dataset.price);
        const ok = (!st.who || who.includes(st.who)) && price >= lo && price <= hi && (!occ || occ.some((o) => who.includes(o)));
        c.hidden = !ok; if (ok) n++;
      });
      const filtered = !!(st.who || st.band || st.occ);
      root.classList.toggle('is-all', filtered || root.dataset.all === '1');
      root.querySelectorAll('.v2-gf__pc').forEach((p) => { const on = p.dataset.v2Who === st.who; p.classList.toggle('is-on', on); p.setAttribute('aria-pressed', String(on)); });
      root.querySelectorAll('[data-v2-band]').forEach((b) => b.classList.toggle('is-on', b.dataset.v2Band === st.band));
      root.querySelectorAll('[data-v2-occ]').forEach((b) => b.classList.toggle('is-on', b === st.occBtn));
      if (title) title.textContent = st.who ? names[st.who] : 'Alle Geschenke';
      if (cnt) cnt.textContent = n;
      if (none) none.hidden = n > 0;
      if (seen) seen.textContent = filtered ? `${n} Geschenke` : (root.dataset.all === '1' ? `${cells.length} von ${cells.length} Geschenken` : `${Math.min(8, cells.length)} von ${cells.length} Geschenken`);
      if (allBtn) allBtn.hidden = filtered || root.dataset.all === '1' || cells.length <= 8;
    };
    root.addEventListener('click', (e) => {
      const w = e.target.closest('[data-v2-who]');
      if (w) { const k = w.dataset.v2Who; st.who = (k && st.who !== k) ? k : ''; if (!k) { st.band = ''; st.occ = null; st.occBtn = null; } apply(); if (w.classList.contains('v2-gf__pc') || !k) root.querySelector('.v2-gf__ghead').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      const b = e.target.closest('[data-v2-band]'); if (b) { st.band = st.band === b.dataset.v2Band ? '' : b.dataset.v2Band; apply(); return; }
      const o = e.target.closest('[data-v2-occ]'); if (o) { if (st.occBtn === o) { st.occ = null; st.occBtn = null; } else { st.occ = o.dataset.v2Occ || null; st.occBtn = o; } apply(); return; }
      if (e.target.closest('[data-v2-gall]')) { root.dataset.all = '1'; apply(); }
    });
  };

  /* »Læg alle tre i kurv« */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-v2-combo]'); if (!b || b.getAttribute('aria-busy') === 'true') return;
    const items = b.dataset.v2Combo.split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 }));
    b.setAttribute('aria-busy', 'true');
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) })
      .then((r) => { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(() => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        const d = document.querySelector('cart-drawer');
        setTimeout(() => { if (d && typeof d.show === 'function') d.show(); else document.querySelector('[aria-controls="cart-drawer"]')?.click(); }, 300);
      })
      .catch(() => { b.textContent = 'Das hat nicht geklappt – bitte versuch es noch einmal'; })
      .finally(() => b.removeAttribute('aria-busy'));
  });

  const run = () => {
    document.querySelectorAll('[data-v2-areas]').forEach((r) => { if (!r.dataset.v2i) { r.dataset.v2i = '1'; initAreas(r); } });
    document.querySelectorAll('[data-v2-gifts]').forEach((r) => { if (!r.dataset.v2i) { r.dataset.v2i = '1'; initGifts(r); } });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
